// 通过canvas获取文字宽度
const getTextWidth = (text, fontSize = '12px') => {
  const dom = document.createElement('span');
  dom.style.display = 'inline-block';
  dom.style.fontSize = fontSize;
  dom.textContent = text;
  document.body.appendChild(dom);
  const width = dom.clientWidth;
  document.body.removeChild(dom);
  return width;
}

export default getTextWidth;